import React, { useState, useEffect, useCallback } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import Nouserimage from "../../../assets/images/users/no_image.png";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import UserService from "Api/Services/UserService";
import { clearStoredSelectedDoctorId } from "helpers/doctorSelection";

const ProfileMenu = props => {
  console.log('ProfileMenu Component Rendering');
  
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [username, setusername] = useState('');
  const [profileImage, setProfileImage] = useState();
  const [refreshInterval, setRefreshInterval] = useState(null);
  const [userToken, setUserToken] = useState(localStorage.getItem("InfuseoneUserToken"));
  const [userRole, setUserRole] = useState(localStorage.getItem("Infuseonerolename"));
  const [isInitialMount, setIsInitialMount] = useState(true);

  console.log('Current State:', {
    username,
    userToken,
    userRole,
    hasProfileImage: !!profileImage,
    error,
    isInitialMount
  });

  const handleLogout = async (e) => {
    console.log('Logout initiated');
    e.preventDefault();
    
    // Clear all states before removing from localStorage
    console.log('Clearing states...');
    setusername('');
    setProfileImage(null);
    setError('');
    setUserToken(null);
    setUserRole(null);
    setIsInitialMount(true);
    
    // Clear localStorage
    console.log('Clearing localStorage...');
    clearStoredSelectedDoctorId();
    localStorage.removeItem("InfuseoneUserToken");
    localStorage.removeItem("Infuseonerolename");
    localStorage.removeItem("Infuseoneuserinfo");
    
    // Clear any existing refresh interval
    if (refreshInterval) {
      console.log('Clearing refresh interval...');
      clearInterval(refreshInterval);
      setRefreshInterval(null);
    }

    // Call logout API to clear server-side session
    try {
      await UserService.userlogout({});
    } catch (error) {
      console.error('Error during logout:', error);
    }
    
    console.log('Logout complete, navigating to home...');
    navigate("/");
  }

  const getUser = useCallback(async () => {
    console.log('getUser called');
    try {
      // Check if we have a valid token before making the API call
      const token = localStorage.getItem("InfuseoneUserToken");
      const role = localStorage.getItem("Infuseonerolename");
      console.log('Current token and role:', { token, role });
      
      if (!token) {
        console.log('No token found, clearing user state');
        setusername('');
        setProfileImage(null);
        return;
      }

      // If role changed, force a fresh fetch
      if (role !== userRole) {
        console.log('Role changed, forcing fresh fetch');
        setUserRole(role);
      }

      console.log('Fetching user data...');
      let response = await UserService.GetUser();
      console.log('User API Response:', response); // Debug log
      
      // Check if we have the correct data structure
      if (response.data) {
        console.log('User Data:', response.data); // Debug log
        // Try different possible field names for the name
        const userName = response.data.name || 
                        response.data.full_name || 
                        response.data.first_name + ' ' + response.data.last_name || 
                        response.data.username;
        console.log('Extracted Username:', userName); // Debug log
        setusername(userName || 'User');
      } else {
        console.warn('No data in response:', response);
        setusername('User');
      }

      const imageUrl = response.data.profile_image
        ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
        : null;
      console.log('Setting profile image URL:', imageUrl);
      setProfileImage(imageUrl)
      
      if (response.status == false) {
        console.error('API returned error status:', response.message);
        setError(response.message);
        return;
      }
    } catch (error) {
      console.error('Error in getUser:', error);
      setError('something went wrong');
      setusername('');
      setProfileImage(null);
      return;
    }
  }, [userRole]);

  // Effect for initial mount and token changes
  useEffect(() => {
    console.log('Initial mount/token effect running');
    const token = localStorage.getItem("InfuseoneUserToken");
    const role = localStorage.getItem("Infuseonerolename");
    
    if (token) {
      console.log('Token found on mount/change, fetching user data');
      setUserRole(role);
      getUser();
      setIsInitialMount(false);
    }
  }, [getUser]);

  // Effect for periodic user data refresh
  useEffect(() => {
    console.log('Refresh effect running, userToken:', userToken);
    if (userToken && !isInitialMount) {
      // Set up periodic refresh every 5 minutes
      console.log('Setting up periodic refresh');
      const interval = setInterval(() => {
        console.log('Periodic refresh triggered');
        getUser();
      }, 5 * 60 * 1000); // 5 minutes

      setRefreshInterval(interval);

      // Cleanup interval on component unmount
      return () => {
        console.log('Cleaning up refresh interval');
        if (interval) {
          clearInterval(interval);
        }
      };
    }
  }, [userToken, getUser, isInitialMount]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={profileImage ? profileImage : Nouserimage}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username ? username : 'User'}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>  */}
            {/* <Link to="/user-profile" className="dropdown-item">
              <i className="bx bx-user font-size-16 align-middle me-1 text-danger" />
              <span>{props.t("Profile")}</span>
            </Link>

            <Link to="/change-password" className="dropdown-item">
              <i className="bx bx-key font-size-16 align-middle me-1 text-danger" />
              <span>{props.t("Change Password")}</span>
            </Link> */}
          {/* <div className="dropdown-divider" /> */}
          <Link to="#" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.any,
};

const mapStateToProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu))
);
